import { CircleCheck } from "lucide-react";

const BorrowerSuccess = ({ closeAddBorrowerSuccess }) => {
  return (
    <div
      onClick={(e) => {
        closeAddBorrowerSuccess();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[500px] h-[250px] flex flex-col justify-center items-center gap-[10px] rounded-[20px] p-[20px] relative bg-white"
      >
        <CircleCheck color="#00A676" />
        <p className="text-[#5C5C5C] text-[16px] font-semibold">
          Success! Borrower Added
        </p>
        <p className="text-[#5C5C5C] text-[16px] text-center font-semibold">
          Borrower has been added successfully into the system.
        </p>
        <button
          onClick={closeAddBorrowerSuccess}
          className="h-[35px] rounded-[30px] bg-[#F3F3F3] px-[20px] text-[#5C5C5C] font-medium text-[15px]"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default BorrowerSuccess;
